import React from 'react';

const FolderIcon = ({ theme, label, isHovered, onClick }) => {
  const folderDay = require('../static/images/folder-day-open.webp');
  const folderNight = require('../static/images/folder-night-open.webp');
  const folderDayClose = require('../static/images/folder-day-close.webp');
  const folderNightClose = require('../static/images/folder-night-close.webp');

  const folderIcon = theme === 'light' ?
    { normal: folderDayClose, hover: folderDay } :
    { normal: folderNightClose, hover: folderNight };

  return (
    <div className="folder-choice" onClick={onClick}>
      <img 
        src={isHovered ? folderIcon.hover : folderIcon.normal} 
        alt={label} 
        className='folder'
      />
      <p>{label}</p>
    </div>
  );
};

export default FolderIcon;